import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { RootState } from "../store/store";
import { setLoading } from "../store/ui/ui";
import { getSheduleData } from "../services/API/shedule";
import { setSheduleDate } from "@/store/schedule/scheduleSlice";

export default function useFetchSchedule() {
    const dispatch = useDispatch();

    const globalDate = useSelector(
        (state: RootState) => state.schedule.globalDate,
    );

    useEffect(() => {
        if (!globalDate) return;
        const fetchData = async () => {
            dispatch(setLoading(true));
            const response = await getSheduleData(globalDate.toLocaleString());
            if (response.data) {
                dispatch(setSheduleDate(response.data));
                dispatch(setLoading(false));
            } else {
                dispatch(setLoading(false));
                toast.error(response.error);
            }
        };
        fetchData();
    }, [globalDate, dispatch]);

    return {};
}
